"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CTGCardView = void 0;
const CTGCard_1 = require("../Logic/CTGCard");
const KHHelperFunctions_1 = require("../KH/KHHelperFunctions");
class CTGCardView extends Phaser.GameObjects.Container {
    constructor(scene, card, dither_fade) {
        super(scene, card.x, card.y);
        this.destroyed = false;
        this.angle = card.rot;
        this.card = card;
        this.card_img = scene.add.sprite(0, 0, 'c6', card.imageId());
        this.add(this.card_img);
        this.card_back = scene.add.sprite(0, 0, 'card_back');
        this.card_back.setVisible(false);
        this.add(this.card_back);
        this.running_tweens = [];
        this.snap_card(card.showing_front);
        // Set up empty array so that we can lazily fill it if not provided.
        if (dither_fade == null) {
            this.dither_fade = [];
            for (let i = 0; i < 17; i++) {
                this.dither_fade.push(null);
            }
        }
        else {
            this.dither_fade = dither_fade;
        }
        this.showing_front = card.showing_front;
        let select_anim = scene.anims.create({
            key: 'anim',
            frames: scene.anims.generateFrameNumbers('selection_anim', {}),
            frameRate: 1,
            repeat: -1
        });
        this.selection_box = scene.add.sprite(0, 0, 'selection_anim');
        this.selection_box.play('anim');
        this.add(this.selection_box);
        this.set_selected(false);
        this.set_alpha_percent(card.alpha);
        let v2 = this.card_img.getTopLeft();
        this.setInteractive(new Phaser.Geom.Rectangle(v2.x + 0.5, v2.y + 0.5, this.card_img.width, this.card_img.height), Phaser.Geom.Rectangle.Contains);
        this.set_can_interact(card.can_interact());
        this.on('pointerdown', function (pointer) {
            if (this.destroyed)
                return;
            this.clicked();
        });
        this.card.registerCallback(CTGCard_1.CTGCard.EVENT_MOVE, (data) => {
            if (this.destroyed)
                return;
            this.x = Math.floor(data.card.x);
            this.y = Math.floor(data.card.y);
        });
        this.card.registerCallback(CTGCard_1.CTGCard.EVENT_FLIP, (data) => {
            if (this.destroyed)
                return;
            this.change_show_front(data.show_front, data.animate);
        });
        this.card.registerCallback(CTGCard_1.CTGCard.EVENT_SELECT, (data) => {
            if (this.destroyed)
                return;
            if (data.audio)
                this.scene.add_sound_to_set('sfx_select');
            this.set_selected(data.selected);
        });
        this.card.registerCallback(CTGCard_1.CTGCard.EVENT_INVALID_PRESS, (data) => {
            if (this.destroyed)
                return;
            this.scene.add_sound_to_set('sfx_cancel');
            this.animate_shake(100);
        });
        this.card.registerCallback(CTGCard_1.CTGCard.EVENT_CAN_INTERACT, (data) => {
            if (this.destroyed)
                return;
            this.set_can_interact(data.can_interact);
        });
        this.card.registerCallback(CTGCard_1.CTGCard.EVENT_ALPHA, (data) => {
            if (this.destroyed)
                return;
            this.set_alpha_percent(card.alpha);
        });
        this.card.registerCallback(CTGCard_1.CTGCard.EVENT_DESTROY, (data) => {
            if (this.destroyed)
                return;
            this.removeInteractive();
            if (data.play_sound) {
                if (this.card.tap_requirement == CTGCard_1.CTGTapRequirement.Dont) {
                    this.scene.add_sound_to_set('sfx_cancel');
                }
                else {
                    this.scene.add_sound_to_set('sfx_destroy');
                }
            }
            if (data.animate) {
                if (data.after_flip) {
                    this.flip_card(200, 0, () => {
                        this.animate_out_scale(50, 100, () => {
                            this.clean_up_and_destroy();
                        });
                    });
                }
                else {
                    this.animate_out_scale(50, 0, () => {
                        this.clean_up_and_destroy();
                    });
                }
            }
            else {
                this.clean_up_and_destroy();
            }
        });
        // Visualize hitbox
        // var graphics = this.scene.add.graphics();
        // graphics.lineStyle(2, 0x00ffff, 1);
        // graphics.strokeRect(this.x + this.input.hitArea.x, this.y + this.input.hitArea.y, this.input.hitArea.width, this.input.hitArea.height);
    }
    update_front() {
        this.card_img.setFrame(this.card.imageId());
    }
    clean_up_and_destroy() {
        this.running_tweens.forEach(element => {
            element.stop();
        });
        this.running_tweens = [];
        this.destroy();
    }
    set_can_interact(can_interact) {
        if (can_interact) {
            this.setInteractive();
        }
        else {
            this.disableInteractive();
        }
    }
    clicked() {
        this.card.tapped();
    }
    set_selected(selected) {
        this.is_selected = selected;
        this.selection_box.setVisible(this.is_selected);
    }
    change_show_front(to_front, animate) {
        if (this.showing_front == to_front) {
            return;
        }
        if (!animate) {
            this.snap_card(to_front);
        }
        else {
            this.flip_card(200);
        }
    }
    snap_card(to_front) {
        this.card_img.setVisible(to_front);
        this.card_back.setVisible(!to_front);
        this.showing_front = to_front;
    }
    add_to_tweens(tween) {
        this.running_tweens.push(tween);
    }
    remove_from_tweens(tween) {
        this.running_tweens = this.running_tweens.filter(function (el) { return el != tween; });
    }
    /**
     * Flips a card to a side if it's not already on that side. Returns whether
     * or not the flip happened.
     */
    maybe_flip_card(to_front, duration, delay = 0, callback) {
        if (this.card.showing_front == to_front) {
            if (callback)
                callback();
            return false;
        }
        else {
            this.flip_card(duration, delay, callback);
            return true;
        }
    }
    flip_card(duration, delay = 0, callback) {
        let from, to;
        if (this.showing_front) {
            from = this.card_img;
            to = this.card_back;
        }
        else {
            from = this.card_back;
            to = this.card_img;
        }
        this.showing_front = !this.showing_front;
        const tween = this.scene.tweens.add({
            targets: from,
            scaleX: 0.01,
            ease: 'Quad.easeIn',
            delay: delay,
            duration: duration / 2,
            onComplete: () => {
                from.setVisible(false);
                to.scaleX = 0.01;
                to.setVisible(true);
                this.scene.tweens.add({
                    targets: to,
                    scaleX: 1,
                    ease: 'Quad.easeOut',
                    duration: duration / 2,
                    onComplete: callback
                });
                this.remove_from_tweens(tween);
            }
        });
        this.add_to_tweens(tween);
    }
    animate_shake(anim_time) {
        let baseX = this.x;
        let amplitude = 2.5;
        const tween = this.scene.tweens.addCounter({
            from: 0,
            to: 100,
            duration: anim_time,
            ease: 'Quad.easeInOut',
            onUpdate: () => {
                this.x = baseX + Math.sin(tween.getValue() * 6.28 / 50) * amplitude;
            },
            onComplete: () => {
                this.x = baseX;
                this.remove_from_tweens(tween);
            }
        });
        this.add_to_tweens(tween);
    }
    animate_out_scale(anim_time, delay = 0, callback) {
        this.scale = 1;
        const tween = this.scene.tweens.add({
            targets: this,
            scale: 0,
            delay: delay,
            ease: 'Linear',
            duration: anim_time,
            onComplete: () => {
                this.remove_from_tweens(tween);
                if (callback)
                    callback();
            }
        });
        this.add_to_tweens(tween);
    }
    animate_in_scale(anim_time, delay = 0, callback) {
        this.scale = 0;
        const tween = this.scene.tweens.add({
            targets: this,
            scale: 1,
            ease: 'Linear',
            delay: delay,
            duration: anim_time,
            onComplete: () => {
                this.remove_from_tweens(tween);
                if (callback)
                    callback();
            }
        });
        this.add_to_tweens(tween);
    }
    animate_drop_in(anim_time, delay = 0, callback) {
        let start = this.y - 64;
        let end = this.y;
        this.y = start;
        const tween = this.scene.tweens.add({
            targets: this,
            y: end,
            ease: 'Quad.easeOut',
            delay: delay,
            duration: anim_time,
            onComplete: () => {
                this.remove_from_tweens(tween);
                if (callback)
                    callback();
            }
        });
        this.add_to_tweens(tween);
    }
    needs_to_animate_onscreen(bounds) {
        let sx = this.x;
        let sy = this.y;
        let ex = Math.max(bounds[0][0], Math.min(bounds[1][0], this.x));
        let ey = Math.max(bounds[0][1], Math.min(bounds[1][1], this.y));
        return sx != ex || sy != ey;
    }
    animate_onscreen(anim_time, bounds, callback) {
        let sx = this.x;
        let sy = this.y;
        let ex = Math.max(bounds[0][0], Math.min(bounds[1][0], this.x));
        let ey = Math.max(bounds[0][1], Math.min(bounds[1][1], this.y));
        if (sx == ex && sy == ey) {
            if (callback)
                callback();
        }
        else {
            const tween = this.scene.tweens.add({
                targets: this,
                x: ex,
                y: ey,
                ease: 'Quad.easeOut',
                duration: anim_time,
                onComplete: () => {
                    if (callback)
                        callback();
                }
            });
        }
    }
    blink(anim_time, times, callback) {
        const tween = this.scene.tweens.addCounter({
            from: 0,
            to: 100,
            duration: anim_time / times,
            repeat: times - 1,
            onUpdate: () => {
                if (tween.getValue() < 10) {
                    this.setVisible(false);
                }
                else if (tween.getValue() > 40) {
                    this.setVisible(true);
                }
            },
            onComplete: callback
        });
    }
    get_dither_fade_idx(idx) {
        idx = Math.floor(idx);
        idx = KHHelperFunctions_1.clamp(0, this.dither_fade.length - 1, idx);
        if (this.dither_fade[idx] == null) {
            let obj = new Phaser.GameObjects.TileSprite(this.scene, 0, 0, 64, 64, 'ditheranim', 'd' + idx).setOrigin(0);
            obj.setVisible(false);
            this.dither_fade[idx] = new Phaser.Display.Masks.BitmapMask(this.scene, obj);
        }
        return this.dither_fade[idx];
    }
    set_dither_fade_idx(idx) {
        idx = Math.max(idx, (1 - this.card.alpha) * (this.dither_fade.length - 1));
        if (idx == 0) {
            this.clearMask();
        }
        else {
            let dither = this.get_dither_fade_idx(idx);
            this.setMask(dither);
        }
    }
    set_alpha_percent(percent) {
        this.set_dither_fade_idx(Math.floor((1 - percent) * (this.dither_fade.length - 1)));
    }
    animate_fade(from, to, anim_time, delay = 0, callback) {
        this.set_dither_fade_idx(from);
        const tween = this.scene.tweens.addCounter({
            from: from,
            to: to,
            duration: anim_time,
            delay: delay,
            onUpdate: () => {
                this.set_dither_fade_idx(tween.getValue());
            },
            onComplete: () => {
                this.remove_from_tweens(tween);
                if (callback)
                    callback();
            }
        });
        this.add_to_tweens(tween);
    }
    animate_in_fade(anim_time, delay = 0, callback) {
        this.animate_fade(this.dither_fade.length - 1, 0, anim_time, delay, callback);
    }
    animate_out_fade(anim_time, delay = 0, callback) {
        this.animate_fade(0, this.dither_fade.length - 1, anim_time, delay, callback);
    }
    animate_flip(obj, anim_time, now) {
        // let frames = 6;
        // let idx = this.ping_pong(0, frames-1, Math.floor(now / (anim_time/frames)));
        // obj.scaleX = idx / (frames-1);
        const widths = [11, 9, 7, 3, 1];
        let idx = KHHelperFunctions_1.ping_pong(0, widths.length - 1, Math.floor(now / (anim_time / widths.length)));
        // Replace this with % array.
        obj.displayWidth = widths[idx];
    }
    animate_zoom(obj, anim_time, now) {
        let frames = 16;
        let idx = KHHelperFunctions_1.ping_pong(0, frames - 1, Math.floor(now / (anim_time / frames)));
        // Replace this with % array.
        obj.setScale(idx / (frames - 1));
    }
    update(now, delta) {
        // this.animate_fade(this.card, 2000, now);
    }
    destroy() {
        this.destroyed = true;
        super.destroy();
    }
}
exports.CTGCardView = CTGCardView;
